import { FREE_LIMIT } from '@/api/consts'
import { Row } from '@/app/components/Flex/Flex'
import { MessageUI } from '@/app/components/MessageUI/MesssageUI'
import { Text } from '@/app/components/Text/Text'
import type { FunctionalComponent } from 'preact'

export const PayMessage: FunctionalComponent<{
  isLegacy: boolean
  hasLoyaltyDiscount?: boolean
  hasPayment?: boolean
}> = props => {
  return (
    <MessageUI type='model'>
      {props.hasLoyaltyDiscount && !props.isLegacy
        ? (
          <Row gap={5}>
            <Text
              fontSize={16}
              fontWeight={600}
              lineHeight={1.3}
            >
              Сообщения закончились
            </Text>
            <Text
              fontSize={16}
              lineHeight={1.3}
            >
              Спасибо, что возвращаешься. Теперь для тебя доступен большой пакет ответов&nbsp;💜
            </Text>
          </Row>
        )
        : props.hasPayment
        ? (
          <Row gap={5}>
            <Text
              fontWeight={600}
              fontSize={16}
              lineHeight={1.3}
            >
              Сообщения закончились
            </Text>
            <Text
              fontSize={16}
              lineHeight={1.3}
            >
              Выбери пакет, чтобы продолжить общение&nbsp;💜
            </Text>
          </Row>
        )
        : (
          <Text
            fontSize={16}
            lineHeight={1.3}
          >
            {FREE_LIMIT > 1
              ? (
                <>
                  Первые {FREE_LIMIT} ответа были бесплатными. Чтобы продолжить общение, выбери пакет.
                </>
              )
              : (
                <>
                  Первый ответ был бесплатным. Чтобы продолжить общение, выбери пакет.
                </>
              )}
          </Text>
        )}
    </MessageUI>
  )
}
